<template>
  <div v-if="showComponent">
    <vs-card>
      <div slot="header">
        <h3>Processo e Datas</h3>
      </div>
      <div>
        <div class="vx-row">
          <!-- Abertura de Processo -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Abertura de Processo</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.aberturaProcesso"
                placeholder="DD/MM/AAAA"
                name="Abertura de Processo"
              />
            </div>
          </div>

          <!-- Solicitação Sindicância -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Solicitação Sindicância</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.solicitacaoSindicancia"
                placeholder="DD/MM/AAAA"
                name="Solicitação Sindicância"
              />
            </div>
          </div>

          <!-- Retorno Sindicância -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Retorno Sindicância</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.retornoSindicancia"
                placeholder="DD/MM/AAAA"
                name="Retorno Sindicância"
              />
            </div>
          </div>

          <!-- Solicitação Vistoria -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Solicitação Vistoria</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.solicitacaoVistoria"
                placeholder="DD/MM/AAAA"
                name="Solicitação Vistoria"
              />
            </div>
          </div>
        </div>

        <div class="vx-row">
          <!-- Retorno Vistoria -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Retorno Vistoria</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.retornoVistoria"
                placeholder="DD/MM/AAAA"
                name="Retorno Vistoria"
              />
            </div>
          </div>

          <!-- Cotação -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Cotação</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.cotacao"
                placeholder="DD/MM/AAAA"
                name="Cotação"
              />
            </div>
          </div>

          <!-- Final Busca -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Final Busca</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.finalBusca"
                placeholder="DD/MM/AAAA"
                name="Final Busca"
              />
            </div>
          </div>

          <!-- Pagamento Participação -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Pagamento Participação</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.pagamentoParticipacao"
                placeholder="DD/MM/AAAA"
                name="Pagamento Participação"
              />
            </div>
          </div>
        </div>

        <div class="vx-row">
          <!-- Pagamento Evento -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Pagamento Evento</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.pagamentoEvento"
                placeholder="DD/MM/AAAA"
                name="Pagamento Evento"
              />
            </div>
          </div>

          <!-- Autorização Reparos -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Autorização Reparos</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.autorizacaoReparos"
                placeholder="DD/MM/AAAA"
                name="Autorização Reparos"
              />
            </div>
          </div>

          <!-- Limite Autorização Reparos -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Limite Autorização Reparos</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.limiteAutorizacaoReparos"
                placeholder="DD/MM/AAAA"
                name="Limite Autorização Reparos"
              />
            </div>
          </div>

          <!-- Entrega Veículo -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Entrega Veículo</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.entregaVeiculo"
                placeholder="DD/MM/AAAA"
                name="Entrega Veículo"
              />
            </div>
          </div>
        </div>

        <div class="vx-row">
          <!-- Acato Documentação -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Acato Documentação</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.acatoDocumentacao"
                placeholder="DD/MM/AAAA"
                name="Acato Documentação"
              />
            </div>
          </div>

          <!-- Prazo Aproximado Reparos -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Prazo Aproximado Reparos</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.prazoAproximadoReparos"
                placeholder="DD/MM/AAAA"
                name="Prazo Aproximado Reparos"
              />
            </div>
          </div>

          <!-- Agendamento Vistoria -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Agendamento Vistoria</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.agendamentoVistoria"
                placeholder="DD/MM/AAAA"
                name="Agendamento Vistoria"
              />
            </div>
          </div>

          <!-- Conclusão Vistoria -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Conclusão Vistoria</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formProcessosDatas.conclusaoVistoria"
                placeholder="DD/MM/AAAA"
                name="Conclusão Vistoria"
              />
            </div>
          </div>
        </div>

        <!-- Localização de Documentação -->
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full mb-2">
            <label class="vs-select--label">Localização de Documentação</label>
            <v-select
              class="selectStyle"
              :options="listLocalizacaoDocumentos"
              name="Localização de Documentação"
              id="Localização de Documentação"
              v-model="formProcessosDatas.idLocalizacaoDocumentacao"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import vSelect from 'vue-select';

export default {
  props: ['formData', 'dominios'],
  components: {
    flatPickr,
    vSelect,
  },
  watch: {
    formData(value) {
      if (!value.processosDatas) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - PROCESSO DATAS FORM');
        return;
      }

      this.formProcessosDatas = Object.assign(
        this.formProcessosDatas,
        value.processosDatas,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.processosDatas = this.formProcessosDatas;
    },
  },
  data() {
    return {
      showComponent: true,
      formProcessosDatas: {
        aberturaProcesso: null,
        solicitacaoSindicancia: null,
        retornoSindicancia: null,
        solicitacaoVistoria: null,
        retornoVistoria: null,
        cotacao: null,
        finalBusca: null,
        pagamentoParticipacao: null,
        pagamentoEvento: null,
        autorizacaoReparos: null,
        limiteAutorizacaoReparos: null,
        entregaVeiculo: null,
        acatoDocumentacao: null,
        prazoAproximadoReparos: null,
        agendamentoVistoria: null,
        conclusaoVistoria: null,
        idLocalizacaoDocumentacao: null,
      },
      listLocalizacaoDocumentos: [],

      //Configuração de componente
      configDateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
    };
  },
  mounted() {
    if (!this.formData.processosDatas) {
      console.error('ERRO NO CONTRATO DO OBJETO - PROCESSO DATAS FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.processosDatas = this.formProcessosDatas;

    this.listLocalizacaoDocumentos = this.dominios.listLocalizacaoDocumentos;
  },
};
</script>

<style scoped>
.selectStyle {
  font-size: 1rem !important;
}

.inputData > input {
  width: 100%;
}
</style>
